import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InspectionList } from '../InspectionList';
import { Profile } from '../Profile';

import { BottomTab, Container, Footer } from './DashboardElements';

export const Dashboard = () => {
  const { t } = useTranslation();
  const [bottomTabIndex, setBottomTabIndex] = useState(0);
  const onChangeBottomTab = (index: number) => setBottomTabIndex(index);

  const bottomTabs = [
    { title: t('inspection.inspection'), icon: 'icon-fi_check-circle' },
    { title: t('profile.profile'), icon: 'icon-profile' },
  ];

  return (
    <Container>
      {bottomTabIndex === 0 && <InspectionList />}
      {bottomTabIndex === 1 && <Profile />}
      <Footer>
        {bottomTabs.map((item, index) => (
          <BottomTab
            key={index}
            isSelected={bottomTabIndex === index}
            onClick={() => onChangeBottomTab(index)}
          >
            <span className={item.icon} />
            <label>{item.title}</label>
          </BottomTab>
        ))}
      </Footer>
    </Container>
  );
};
